// extracted by mini-css-extract-plugin
export default {"section":"styles_section__2AvM-","container":"styles_container__ebB51","card":"styles_card__6ukF+"};